import  Vue from 'vue'
import  Vuex from 'vuex'

import address from './address'
import goods from './goods'
import agent from './agent'
import price from './price'
import agentuser from './agent_user'
import purchase_order from './purchase_order'
import shop_cart from './shop_cart'
import wallet from './wallet'
import login from './login'
import category from './category'
import attr from './attr'
import area from './area'
import order from './order'
import attr_name from './attr_name'
import search_agent_user from './search_agent_user'
import statistical from './statistical'
import service from './service'
import withdrawal from './withdrawal'
import order_profits from './order_profits'
import password from './password'
import agent_password from './agent_password'
import order_payment from './payment'
import stock from './stock'
import product_price from './product_price'
import  express from './express'
import  recharge from './recharge'
import  examine from  './examine'
import  roles from  './roles'
import  product_group from  './product_group'
import  product_group_goods from  './product_group_goods'
import  product_group_user from  './product_group_user'
import  logistics from  './logistics'
import  express_price from  './express_price'
import  menu from  './menu'
import  roles_menu from  './roles_menu'
import  member from  './member'
import  wechat_menu from  './wechat_menu'
import  article from  './article'
Vue.use(Vuex)
const store = new Vuex.Store({

   modules:{
      
       address:address,
       goods:goods,
       agent:agent,
       price:price,
       agentuser:agentuser,
       purchase_order:purchase_order,
       shop_cart:shop_cart,
       wallet :wallet,
       login:login,
       category:category,
       attr:attr,
       area:area,
       order:order,
       attr_name:attr_name,
       search_agent_user:search_agent_user,
       statistical:statistical,
       order_service:service,
       withdrawal:withdrawal,
       order_profits:order_profits,
       password:password,
       payment:order_payment,
       agent_password:agent_password,
       stock:stock,
       product_price:product_price,
       express:express,
       recharge:recharge,
       examine:examine,
       roles:roles,
       product_group:product_group,
       product_group_goods:product_group_goods,
       product_group_user:product_group_user,
       logistics:logistics,
       express_price:express_price,
       menu:menu,
       roles_menu:roles_menu,
       member:member,
       wechat_menu:wechat_menu,
       article:article

       
      
   }
})

export default store